import React from "react"
import type { PerformerInterest } from "./types"

interface PerformersInterestTableProps {
  performers: PerformerInterest[]
}

// Shared by the pre-payout preview page (/payout-distribution/post/:id,
// before a Payout record exists) and the payout page
// (/dashboard/payouts/:id) - same lineup, same ticket/interest attribution,
// so both should read identically regardless of which one a link happens
// to land on.
export const PerformersInterestTable: React.FC<PerformersInterestTableProps> = ({
  performers,
}) => {
  if (!performers.length) return null

  return (
    <div className="mt-4">
      <h2 className="font-bold text-lg uppercase mb-2">Performers</h2>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left uppercase text-xs border-b-2 border-black">
            <th className="py-1 font-bold">Band</th>
            <th className="py-1 font-bold">Tickets Sold</th>
            <th className="py-1 font-bold">Interested Count</th>
            <th className="py-1 font-bold">Extrapolated Sold</th>
          </tr>
        </thead>
        <tbody>
          {performers.map((performer) => (
            <tr key={performer.event_performance_id} className="border-b border-gray-200">
              <td className="py-1">
                {performer.bandnada_url ? (
                  <a
                    href={performer.bandnada_url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    {performer.name}
                  </a>
                ) : (
                  performer.name
                )}
              </td>
              <td className="py-1">{performer.tickets_sold}</td>
              <td className="py-1">
                {performer.interest_count == null
                  ? "n/a"
                  : performer.interest_percentage != null
                    ? `${performer.interest_count} (${performer.interest_percentage}%)`
                    : performer.interest_count}
              </td>
              <td className="py-1">{performer.extrapolated_tickets_sold ?? "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default PerformersInterestTable
